// @ts-expect-error TS7016, tinymce has not yet been migrated.
import tinymce from 'tinymce';
import { HS_DATA_TOKEN } from '../constants/plugins';
import { initDataTokens } from '../utils/dataTokens';
import { addControls } from './controls';
import { getInsertDataToken } from './handlers';
import { addTransforms, handleDataTokensLoaded } from './shared';
import { getHsDataTokenSettings } from './utils';
function hsDataTokenPlugin(editor) {
  const dataTokenSettingsConfig = getHsDataTokenSettings(editor);
  if (!dataTokenSettingsConfig) {
    return {};
  }
  const {
    useAsUpgradePoint
  } = dataTokenSettingsConfig;
  addControls(editor, dataTokenSettingsConfig, useAsUpgradePoint);
  if (useAsUpgradePoint) {
    // Don't render the transforms or init data tokens if it's only an upgrade point
    return {};
  }
  addTransforms(editor);
  tinymce.canvas.addIdleCallback(editor, '[data-mce-token-path]', () => initDataTokens(editor, dataTokenSettingsConfig).then(() => {
    handleDataTokensLoaded(editor);
  }));
  return {
    insertDataToken: getInsertDataToken(editor)
  };
}
tinymce.PluginManager.add(HS_DATA_TOKEN, hsDataTokenPlugin);